import detectEthereumProvider from '@metamask/detect-provider'
import storage from '@/store/index'
import jsCookie from 'js-cookie'

import ToastificationContent from "@core/components/toastification/ToastificationContent"
import walletAuth from '@/auth/wallet/auth'

import Vue from "vue"
import Toast from 'vue-toastification'

import Web3 from 'web3'

Vue.use(Toast, {
    hideProgressBar: true,
    closeOnClick: false,
    closeButton: false,
    icon: false,
    timeout: 3000,
    transition: 'Vue-Toastification__fade'
})

function metamaskUtils (options) {
    this.default = {
        network: process.env.VUE_APP_NETWORK,
        networkName: 'ETH'
    }
    
    this.provider
    this.account
    // this.initlization()
    let option = {
        onChainChanged: () => {
            this.cacheClear()
            window.location.reload()
        },
        onAccountChanged: account => {
            console.log('account change:', account)
            console.log(storage.getters['wallet/account'])
            if (!account || account.length==0 || (account[0]!==storage.getters['wallet/account']&&storage.getters['wallet/account'])) {
                this.cacheClear()
                window.location.reload()
            }
        },
        onDisconnect: err => { 
            console.error(err)
            return
         },
    }

    if (options)
        Object.assign(option, options)

    if (window.ethereum) {
        ethereum.on('chainChanged', option['onChainChanged'])
        ethereum.on('accountsChanged', option['onAccountChanged'])
        ethereum.on('disconnect', err => {
            option.onDisconnect(err)
            console.error(err)
        })

    }

}

metamaskUtils.prototype.initlization = async function(){
    /* 检测是否安装钱包 */
    this.provider = await detectEthereumProvider()
    // storage.commit('wallet/provide', this.provider)
    if (window.ethereum !== this.provider)  window.ethereum == this.provider

    if (this.provider) {
        this.selectNetwork()
        /* 连接钱包，eth_requestAccounts  */
        try {
            const accounts = await ethereum.request({ method: 'eth_requestAccounts' });
            this.account = accounts[0];
            storage.commit('wallet/account', this.account)
        } catch (err) {
            this.showError(err.message || err)
        }
    } else {
        // console.error()
        this.showError('Please install MetaMask')
    }

}

metamaskUtils.prototype.getNetworkVersion = async function(){
    const chainId = await ethereum.request({ method: 'eth_chainId' });
    const networkId = await ethereum.request({ method: 'net_version' });
    return { chainId, networkId }
}

metamaskUtils.prototype.networkCheck = async function() {
    let currentChainOptions = await this.getNetworkVersion()
    if (currentChainOptions.networkId != this.default.network) {
        let msg_ = `
            Current network ${currentChainOptions.networkId} is not supported
        `
        // console.error(msg_)
        this.showError(msg_)
        return false
    }
    return true
}

metamaskUtils.prototype.ethSign = function(){
    const msg = authMsg(this.account);
    return new Promise(async (resolve, refuce) => {
        let check_ = await this.networkCheck()
        if (!check_) return false

        if (storage.getters['wallet/eth_sign']) {
            resolve(storage.getters['wallet/eth_sign'])
            return false
        }

        try {   
            const ethResult = await ethereum.request({
                method: 'personal_sign',
                params: [msg, this.account],
            });
            storage.commit('wallet/eth_sign', ethResult)
            resolve(ethResult)
            
        } catch (err) {
            this.showError(err.message || err)
            refuce(err)
        }
    })
}

metamaskUtils.prototype.signCheck = async function() {
    if(Boolean(storage.getters['wallet/eth_sign']) != false && Boolean(storage.getters['wallet/auth_msg']))
        return true
    else
        return false
}

metamaskUtils.prototype.selectNetwork = async function () {
    let currentChainOptions = await this.getNetworkVersion()
    // console.log(currentChainOptions)
    if (currentChainOptions.networkId == this.default.network) return false

    const web3_ = new Web3(this.provider)
    const targetChainID = web3_.utils.toHex(this.default.network)
    try {
        await window.ethereum.request({method: 'wallet_switchEthereumChain', params: [{chainId: targetChainID}]})
    } catch (e) {
        if(e.code == 4902) {
            try {
                await window.ethereum.request({ method: 'wallet_addEthereumChain', params: [{
                        chainId: targetChainID,
                        chainName: this.default.networkName,
                        nativeCurrency : { name : 'ETH', symbol : 'ETH', decimals : 18},
                        rpcUrls: 'https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161',
                        blockExplorerUrls: 'https://etherscan.io'
                    }]})
            } catch (adderr) {
                console.log("Add chain failed.", adderr);
            }

        } else {
            console.log(e)
        }
    }
}

metamaskUtils.prototype.showError = function(err) {
    console.error(err)
    Vue.$toast({
        component: ToastificationContent,
        props: {
            text: err,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
        },
    })
}

metamaskUtils.prototype.cacheClear = function() {
    if(document.cookie) {
        var keys=document.cookie.match(/[^ =;]+(?=\=)/g);
        keys.forEach(item => {
            jsCookie.remove(item)
        })
    }
    
    localStorage.removeItem(walletAuth.config.userData)
    localStorage.removeItem(walletAuth.config.userToken)
}


function authMsg(account) {
    const msg = storage.getters['wallet/auth_msg'] ? storage.getters['wallet/auth_msg'] : JSON.stringify({
        timestamp: (Date.now()/(1000*3600)).toFixed(),
        space: account,
        type: 'personal_sign'
    })

    storage.commit('wallet/auth_msg', msg)
    return msg
}



export default metamaskUtils
        


        


        


        


        


        


        

